<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <div class="row align-items-center mb-3 d-flex justify-content-between">
        <h2 class="custom-card-title headLeft">Grants</h2>
        <!-- Search -->
        <div class="col-12 col-md-5 mb-3 headLeft">
          <input type="text" class="form-control" placeholder="Search grants..."
                 [(ngModel)]="searchValue"
                 (ngModelChange)="filter(searchValue)">
        </div>

        <div class="col-12 col-md-5 mb-3 d-flex justify-content-md-end gap-2 headRight">
          <select *ngIf="teacher?.role === 'Admin'" class="form-select mb-3" (change)="showGrants($event)">
            <option selected value="All Grants">All Grants</option>
            <option value="Deleted">Deleted</option>
            <option value="Undeleted">Undeleted</option>
          </select>

          <div class="flex-shrink-0">
            <a routerLink="/grants-form" class="btn btn-primary d-flex align-items-center"
               *ngIf="(teacher?.role ?? '').toLowerCase() === 'admin'">
              New Grant
              <span class="material-symbols-outlined ms-1">add</span>
            </a>
          </div>

          <div class="flex-shrink-1" style="min-width: 100px;">
            <select class="form-select" aria-label="Number of cards per page" (change)="selectChange($event)">
              <option selected value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="All">All</option>
            </select>
          </div>
        </div>

        <div style="margin: 0" id="row-section">
          <div>
            <table class="table">
              <thead>
              <tr>
                <th (click)="sort('status')">
                  <select class="form-select form-select-sm" (change)="onStatusSortChange($event)">
                    <option value="">Grant Status</option>
                    <option *ngFor="let status of grantStatusOrder" [value]="status">{{ status }}</option>
                  </select>
                </th>
                <th (click)="sort('name')">
                  Grant Name
                  <span *ngIf="getSortDir('name') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('name') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('name') !== 'desc' && getSortDir('name') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('open')">
                  Grant Application Open
                  <span *ngIf="getSortDir('open') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('open') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('open') !== 'desc' && getSortDir('open') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('close')">
                  Grant Application Close
                  <span *ngIf="getSortDir('close') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('close') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('close') !== 'desc' && getSortDir('close') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('link')">
                  Grant Web Link
                  <span *ngIf="getSortDir('link') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('link') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('link') !== 'desc' && getSortDir('link') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
              </tr>
              </thead>
              <tbody *ngIf="pagedCards.length > 0; else noGrants">
              <ng-container *ngFor="let grant of pagedCards; let i = index">

                <tr (click)="onGrantClicked(grant)">
                  <td>{{ grant.status }}</td>
                  <td>{{ grant.name }}</td>
                  <td>{{ grant.applicationOpenDate | date:'MMM d, yyyy' }}</td>
                  <td>{{ grant.applicationCloseDate | date:'MMM d, yyyy' }}</td>
                  <td>
                    <a [href]="grant.webLink" target="_blank" rel="noopener">
                      {{ grant.webLink }}
                    </a>
                  </td>
                </tr>

              </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination (only if more than one page) -->
        <ul class="pagination headLeft" *ngIf="totalPages > 1">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="goToPrevious()">Previous</a>
          </li>

          <li
            *ngFor="let page of pages"
            class="page-item"
            [class.active]="page === currentPage"
          >
            <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
          </li>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="goToNext()">Next</a>
          </li>
        </ul>

        <ng-template #noGrants>
          <div class="col-12">
            <p class="mb-4">There are no grants.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

